import { sdkRequest } from '@eb/http';

export const followOrganizer = (organizerId) =>
    sdkRequest(`/api/v3/destination/organizers/${organizerId}/follow/`, {
        method: 'POST',
        body: JSON.stringify({}),
    });
